"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8947],{

/***/ 58947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88309);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const InfoBox2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 6397).then(__webpack_require__.bind(__webpack_require__, 6397)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(6397)]
  }
});

const InfoBoxContainer2 = _ref => {
  let {
    title,
    boldTitle,
    description,
    boldDescription,
    action,
    actionTitle,
    href
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(InfoBox2, {
    title: title,
    boldTitle: boldTitle,
    description: description,
    boldDescription: boldDescription,
    action: action,
    actionTitle: actionTitle,
    href: href || '/page-here',
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
  });
};

/* harmony default export */ __webpack_exports__["default"] = (InfoBoxContainer2);

/***/ }),

/***/ 88309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



const MessageIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        transform: "translate(-275 -3084) translate(275 3084)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
          cx: "40",
          cy: "40",
          r: "40",
          fill: "#41A476"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
          fill: "#FFF",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22.617 55c.211 0 .43-.062.624-.211l10.978-8.226h12.656c3.102 0 5.625-2.523 5.625-5.625V15.625c0-3.102-2.523-5.625-5.625-5.625h-33.75C10.022 10 7.5 12.523 7.5 15.625v25.313c0 3.102 2.522 5.625 5.625 5.625h8.437v7.382c0 .624.51 1.055 1.055 1.055zm3.164-7.383v-5.273H13.125c-.773 0-1.406-.633-1.406-1.406V15.625c0-.773.633-1.406 1.406-1.406h33.75c.773 0 1.406.633 1.406 1.406v25.313c0 .773-.633 1.406-1.406 1.406H32.812l-1.125.843-5.906 4.43zM18.75 31.094c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813zm11.25 0c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813zm11.25 0c1.556 0 2.812-1.257 2.812-2.813 0-1.555-1.256-2.812-2.812-2.812-1.556 0-2.813 1.257-2.813 2.812 0 1.556 1.257 2.813 2.813 2.813z",
            transform: "translate(10 10)"
          })
        })]
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (MessageIcon);

/***/ })

}]);